// extracted by mini-css-extract-plugin
export var socialIcon = "FooterSocialSection-module--socialIcon--710d8";
export var socialLink = "FooterSocialSection-module--socialLink--494eb";
export var socialLinks = "FooterSocialSection-module--socialLinks--94a24";
export var socialSection = "FooterSocialSection-module--socialSection--2cc0e";